export default __webpack_public_path__ + "static/media/ic_text-align-left.ba5ebdc7.svg";